import { useEffect } from 'react';
// https://stackoverflow.com/a/56767883
// enables single fire useEffect on component mount. Stops errors with
// eslint-disable-next-line react-hooks/exhaustive-deps
export const useMountEffect = (fN) => useEffect(fN, []);
